import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixCalendarEventviewsV3EventViewsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/calendar/v3/events/view',
        destPath: '/v3/events/view',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/calendar/v3/events/view',
        destPath: '/v3/events/view',
      },
    ],
    _: [
      {
        srcPath: '/_api/calendar/v3/events/view',
        destPath: '/v3/events/view',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/calendar/v3/events/view',
        destPath: '/v3/events/view',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_calendar_event-views';

/**
 * Doesn’t return details about events within the view. You can use
 * [queryEvents()](https://dev.wix.com/docs/sdk/backend-modules/calendar/events/query-events),
 * providing `eventsView.endDate` as `toLocalDate` to retrieve the
 * events.
 */
export function getEventsView(payload: object): RequestOptionsFactory<any> {
  function __getEventsView({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.calendar.v3.events_view',
      method: 'GET' as any,
      methodFqn: 'wix.calendar.eventviews.v3.EventViewsService.GetEventsView',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixCalendarEventviewsV3EventViewsServiceUrl({
        protoPath: '/v3/events/view',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'eventsView.endDate' }],
          },
        ]),
    };

    return metadata;
  }

  return __getEventsView;
}
